import { h, FunctionalComponent } from 'preact'
import GroupJoin from '../groups-destination/GroupJoin'

const SiteWideComponents: FunctionalComponent = () => {
  return (
    <div>
      <GroupJoin />
    </div>
  )
}

export default SiteWideComponents
